import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectAllEntities} from '@ngneat/elf-entities';
import {invoicingPeriodStore} from '@store/settings/invoicingPeriod/invoicing-period.store';

export const getInvoicingPeriodDataSource = createRequestDataSource({
  store: invoicingPeriodStore,
  data$: () => invoicingPeriodStore.pipe(
    selectAllEntities(),
  ),
  requestKey: 'getInvoicingPeriod',
  dataKey: 'invoicingPeriods',
});
